<template>
  <div>
    <div id="sharedGameCreate" :class="['modal', modalOpenClass]">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              {{$t('modal.sharedGame.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              {{$t('modal.sharedGame.description')}}
              <br>
              <div class="has-text-centered" v-if="!hasHostedGame">
                <button class="button" @click="createSession()">
                  {{$t('modal.sharedGame.createSessionButton')}}
                </button>
              </div>
              <div class="has-text-centered" v-if="hasHostedGame">
                <h3 class="title">
                  {{$t('modal.sharedGame.shareWithFriendsLink')}}
                </h3>
                <h4 class="title is-4">
                  {{ siteUrl}}/{{ hostedGame.uri}}
                </h4>
              </div>

            </div>
          </div>
          <footer class="card-footer has-text-right">
            <div class="">
              <button class="button is-danger" @click="closeModal()">{{$t('close')}}</button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SharedGame',
  computed: {
    modalOpenClass () {
      if (this.isModalOpen) {
        return 'is-active'
      }

      return ''
    }
  },
  data: function () {
    return {
      isModalOpen: false,
      hasHostedGame: false,
      hostedGame: {}
    }
  },
  props: ['siteUrl', 'firstCard'],
  methods: {
    closeModal () {
      this.isModalOpen = false
    },
    openModal () {
      this.isModalOpen = true
    },
    createSession () {
      axios.post('https://totally-wasted-api-prod.azurewebsites.net/game/sessions', { nextid: '' + this.firstCard })
        .then((response) => {
          this.hostedGame = response.data
          this.hasHostedGame = true
        }).catch(function (error) {
          console.log(error)
        })
    },
    getSessionDetails () {
      return this.hostedGame
    }
  }
}
</script>

<style scoped>

</style>
